import { connect } from 'react-redux';
import { setAppInfo, init, setLoading } from '../actions/app';
import { confirmLogout } from '../actions/auth';
import AppChooser from '../components/AppChooser/AppChooser';
import history from '../utils/history';

const mapStateToProps = (state) => {
  return {
    apps: state.app.appList,
    loading: state.app.loading,
    error: state.app.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    chooseApp: (appCode) => {
      history.push(`/${appCode}`);
      dispatch(setLoading(true));
      dispatch(setAppInfo(appCode));
      dispatch(init());
    },
    logout: () => {
      dispatch(confirmLogout());
    },
  };
};

const AppSelector = connect(mapStateToProps, mapDispatchToProps)(AppChooser);

export default AppSelector;
